/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import styles from 'lorastyles/base.scss';

const PageLoading = () => (
  <div className={styles.loading}>
    <i className="fa fa-spinner fa-spin fa-5x" />
  </div>
);

export default PageLoading;




// WEBPACK FOOTER //
// ./src/components/PageLoading.jsx